export class EmployeeCommands {
  public static readonly EMPLOYEE_CHANGED = 'employee_notifyEmployeeChanged';

  public static readonly EMPLOYEE_QUOTA_CHANGED =
    'employee_notifyEmployeeQuotaChanged';
}
